"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifDefined = ifDefined;

function ifDefined(value, thenFn, elseFn) {
  if (value === null || value === undefined) {
    return elseFn();
  } else {
    return thenFn(value);
  }
}
//# sourceMappingURL=ifDefined.js.map